import { TableCell } from "@mui/material";
import CellCheckBox from "./CellCheckBox";
import { snakeCaseToNormalText } from "../utils";
import { TableDataProps, PermissionsProps } from "../PermissionProps";

export const TabelRowData = (props: TableDataProps) => {
  const { modulePermission, moduleName, onChange, initialData, rowHeader } =
    props;

  const onHandleChange = (data: PermissionsProps) => {
    onChange && onChange(data, moduleName);
  };

  return (
    <>
      <TableCell>{snakeCaseToNormalText(moduleName)}</TableCell>
      {rowHeader?.map((item: string) => {
        return (
          <CellCheckBox
            key={item}
            id={item}
            disable={!modulePermission[item]}
            onHandleChange={onHandleChange}
            permission={initialData}
          />
        );
      })}
    </>
  );
};
